import React from 'react';
import { motion } from 'framer-motion';
import { Check, Lock, Download, ShieldCheck } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function OfferSection() {
  return <section id="offer-section" className="bg-gradient-to-b from-sage-light to-sage py-20 md:py-32 px-4" data-id="element-165">
      <div className="max-w-4xl mx-auto text-center" data-id="element-166">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-167">
          <span className="text-white font-bold tracking-widest text-sm uppercase mb-4 block opacity-90" data-id="element-168">
            Oferta Especial de Lanzamiento
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-6" data-id="element-169">
            Tu momento de reconexión empieza aquí
          </h2>
          <p className="text-xl text-white/90 font-light" data-id="element-170">
            Acceso inmediato · Pago único · Sin suscripciones · Tuyo para
            siempre
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-[0_20px_60px_-15px_rgba(0,0,0,0.3)] relative max-w-3xl mx-auto" data-id="element-171">
          <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-warm-accent text-white font-bold px-6 py-2 rounded-full text-sm whitespace-nowrap shadow-lg flex items-center gap-2" data-id="element-172">
            <span data-id="element-173">⏰</span> Solo por 3 días · Oferta de lanzamiento
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center mt-6" data-id="element-174">
            <div className="order-2 md:order-1" data-id="element-175">
              <img src="https://cdn.magicpatterns.com/uploads/wGV6FdLUgwCFMi4G1vf84W/PORTADA3D_(2).png" alt="Plan Antiinflamatorio" className="w-full max-w-sm mx-auto drop-shadow-xl" data-id="element-176" />
            </div>

            <div className="order-1 md:order-2 text-left flex flex-col justify-center" data-id="element-177">
              <h3 className="text-2xl md:text-3xl font-heading font-bold text-olive mb-6" data-id="element-178">
                Plan Antiinflamatorio Después de los 40
              </h3>

              <div className="bg-cream p-6 rounded-2xl mb-6 border border-sage/20" data-id="element-179">
                <div className="flex items-center gap-3 text-warm-gray mb-1" data-id="element-180">
                  <span className="line-through text-lg" data-id="element-181">$19.99 USD</span>
                  <span className="bg-warm-accent text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-182">
                    -50% OFF
                  </span>
                </div>
                <div className="text-5xl font-bold text-olive font-heading mb-2" data-id="element-183">
                  $6.36 <span className="text-2xl" data-id="element-184">USD</span>
                </div>
                <p className="text-sage font-medium text-sm" data-id="element-185">
                  Oferta de lanzamiento · Solo por 3 días
                </p>
              </div>

              <ul className="space-y-3 mb-8" data-id="element-186">
                {['Guía Principal: Plan Antiinflamatorio +40 (más de 80 págs)', 'Formato PDF — Acceso de por vida', 'Descarga inmediata'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-187">
                    <Check className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-188" />
                    <span className="text-warm-gray font-medium" data-id="element-189">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="mt-8 pt-8 border-t border-gray-100" data-id="element-190">
            <a href="https://www.yennilemon.com/cart/44211058212999:1" target="_blank" rel="noopener noreferrer" onClick={trackInitiateCheckout} className="block w-full bg-olive hover:bg-olive-light text-white font-bold py-5 px-8 rounded-full transition-all transform hover:scale-[1.02] shadow-lg text-lg md:text-xl text-center" data-id="element-191">
              ✨ Quiero comenzar mi transformación — $6.36 USD
            </a>

            <div className="flex flex-wrap justify-center gap-4 md:gap-8 mt-6 text-sm text-warm-gray font-medium" data-id="element-192">
              <span className="flex items-center gap-2" data-id="element-193">
                <Lock className="w-4 h-4 text-sage" data-id="element-194" /> Pago 100% seguro
              </span>
              <span className="flex items-center gap-2" data-id="element-195">
                <Download className="w-4 h-4 text-sage" data-id="element-196" /> Descarga inmediata
              </span>
              <span className="flex items-center gap-2" data-id="element-197">
                <ShieldCheck className="w-4 h-4 text-sage" data-id="element-198" /> Garantía 7 días
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}